import { forgetRail } from "./rail-memory";

/**
 * Leaving a shared session: Switch user and the idle sign-out (sign-in-methods.md B.2, TC-UI-008).
 * The person's rail choice is removed first, so the next person starts expanded even if the
 * sign-out request fails or the browser ignores the server's Clear-Site-Data. Then the session ends
 * and the page is replaced (a full load, nothing of the last person in memory or in Back).
 */
export interface LeaveDeps {
  signOut: () => Promise<unknown>;
  replace: (to: string) => void;
  /** For tests; the browser's localStorage otherwise. */
  store?: Storage | null;
}

export async function leaveShared(to: string, who: { tenant?: string | null; user?: string | null } | null | undefined, d: LeaveDeps): Promise<void> {
  forgetRail(who?.tenant, who?.user, d.store);
  try { await d.signOut(); } catch { /* already gone */ }
  d.replace(to);
}
